import React from 'react';
import { useLocation } from 'react-router-dom';

import OneColumnHeader from './Header/Header';
import DataRouter from '../../../router/DataRouter';
// import GlobalRouter from '../../../router/GlobalRouter';

// import DefaultRouter from '../../router';

export default function OneColumnLayout() {
  const location = useLocation();
  return (
    <>
      {!location.pathname.includes('training-webinars') && <OneColumnHeader />}
      <DataRouter />
    </>
  );
}
